import type { UserRegionalIdentity } from '../types/user.type'

export function hasRegionalIdentityForRegion(identities: UserRegionalIdentity[], region: string): boolean {
  return identities.some((identity) => identity.region === region)
}
